import React from 'react'
function Button(props){

    return (
      <section className="navbar-section">
        <span className="badge" tabIndex="-1">
          <i className="icon icon-mail icon-2x c-hand hvr-pulse"></i>
        </span>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <button className="btn hvr-pulse" lang="zh-Hans" tabIndex="-1">登录</button>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
      </section>
    )
}

export default Button



// WEBPACK FOOTER //
// ./src/topModule/Button.js